import Step1 from './Step1.vue';

export default [
  {
    label: 'General',
    view: Step1,
  },
];
